import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingLegend from '../HarvestAndPlantingLegend';

export function PlantingLegend(props) {
  return <HarvestAndPlantingLegend {...props} />;
}

PlantingLegend.propTypes = {
  dates: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const { list } = state.seasons;
  const { plantingEndDate, plantingStartDate, plantingYear } =
    list[activeSeason.id];
  const dates = {
    endDate: plantingEndDate,
    startDate: plantingStartDate,
    year: plantingYear,
  };

  return {
    dates,
  };
}

export default connect(mapStateToProps)(PlantingLegend);
